import { ExpenseList } from "@/components/expenses/expense-list";

export default function Expenses() {
  return (
    <div className="container mx-auto px-4 py-6 max-w-2xl pb-24">
      <h1 className="text-2xl font-bold mb-6">Expenses</h1>
      <ExpenseList />
    </div>
  );
}
